import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select", "height", "width", "length", "volume", "quantity"];

  connect() {
    this.calculate();
  }

  calculateVolumeCBM(length, width, height, quantity) {
    const cm3Tom3 = 1000000.0;
    return ((height * width * length) / cm3Tom3) * quantity;
  }

  changed() {
    let packageTypeId = this.selectTarget.value;
    $.getJSON(`/admin/package_types/${packageTypeId}/certain_pakage_type`, (data) => {
      if (
        !data.default_width_mm == "" ||
        !data.default_length_mm == "" ||
        !data.default_height_mm == ""
      ) {
        this.widthTarget.value = (data.default_width_mm / 10).toFixed(1);
        this.lengthTarget.value = (data.default_length_mm / 10).toFixed(1);
        this.heightTarget.value = (data.default_height_mm / 10).toFixed(1);
      } else {
        this.widthTarget.value = "";
        this.lengthTarget.value = "";
        this.heightTarget.value = "";
        return;
      }
      this.calculate();
    });
  }

  calculate() {
    if (!this.lengthTarget.value || !this.widthTarget.value || !this.heightTarget.value) {
      this.volumeTarget.disabled = false;
      return;
    }

    this.volumeTarget.disabled = true;

    this.volumeTarget.value = this.calculateVolumeCBM(
      this.lengthTarget.value,
      this.widthTarget.value,
      this.heightTarget.value,
      this.quantityTarget.value
    );
    this.volumeTarget.dispatchEvent(new Event("change"));
  }
}
